export default EnergyPriceLevels;

function EnergyPriceLevels(vat = 1) {
  let priceLevels = {};
const basePriceLevels = {"low":"0","medium":"120","concerning":"140","high":"230"};

  for (let key in basePriceLevels) {
    priceLevels[key] = Math.round((basePriceLevels[key] * vat) / 10) * 10;
  }

  return priceLevels;
}
